<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group required">
          <label for="nome">Nome</label>
          <input type="text" class="form-control" name="nome" id="nome" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group required">
          <label for="cpf">CPF</label>
          <input
            type="text"
            class="form-control cpf-validation"
            name="cpf"
            id="cpf"
            v-mask="['###.###.###-##']"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group required">
          <label for="email">E-mail</label>
          <input
            type="email"
            class="form-control email-validation"
            name="email"
            id="email"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group required">
          <label for="phone">Telefone</label>
          <input
            type="text"
            class="form-control"
            name="phone"
            id="phone"
            v-mask="['(##) ####-####', '(##) #####-####']"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group required">
          <label style="margin-bottom: 5px">Escritório</label>
          <select-component
            name="cod_escritorio"
            v-model="escritorio"
            @change="onChangeEscritorio"
            v-cloak
          >
            <option value="">Selecione</option>
            <option
              v-for="(item, index) of escritorios"
              :key="index"
              :value="item.id_uad"
              >{{ item.ds_localizacao }}</option
            >
          </select-component>
          <input
            type="hidden"
            name="nome_escritorio"
            :value="getNomeEscritorio"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div class="form-group required">
          <label>Dia</label>
          <date-picker
            v-model="data"
            format="DD/MM/YYYY"
            :disabled-date="notBeforeToday"
            @change="hora = ''"
          ></date-picker>
        </div>
      </div>
      <div class="col-sm-6 col-md-3">
        <div class="form-group required">
          <label>Hora</label>
          <date-picker
            type="time"
            v-model="hora"
            format="HH:mm"
            :disabled-time="disabledTimes"
            :time-picker-options="{
              start: '08:20',
              step: '00:20',
              end: '11:40',
              format: 'HH:mm'
            }"
            @open="onOpenTimepicker"
          ></date-picker>
          <input type="hidden" name="horario" :value="getHorario" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required">
          <label for="assunto">Assunto a tratar</label>
          <textarea
            name="assunto"
            id="assunto"
            cols="5"
            class="form-control"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12"></div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";

export default {
  components: { DatePicker },
  props: {
    escritorios: {
      required: true
    },
    horariosIndisponiveis: {
      required: true
    }
  },
  data: () => ({
    data: "",
    hora: "",
    escritorio: "",
    nome_escritorio: ""
  }),
  computed: {
    getNomeEscritorio() {
      const escritorio = this.escritorios.find(
        item => item.id_uad == this.escritorio
      );
      if (escritorio) {
        return escritorio.ds_localizacao;
      }
      return "";
    },
    getHorario() {
      if (this.data && this.hora) {
        return (
          moment(this.data).format("YYYY-MM-DD") +
          " " +
          moment(this.hora).format("HH:mm")
        );
      }
      return "";
    }
  },
  methods: {
    onChangeEscritorio(ev) {
      this.escritorio = ev;
    },
    onSaveClick(ev) {
      ev.preventDefault();
      $("#form-marcacao").submit();
    },
    notBeforeToday(date) {
      return date <= moment().subtract(1, "days");
    },
    onOpenTimepicker() {
      if (!this.data || !this.escritorio) {
        this.$toast.warning("Preencha o escritório e o dia primeiro");
      }
    },
    disabledTimes(time) {
      if (!this.data || !this.escritorio) {
        return true;
      }

      const horario =
        moment(this.data).format("YYYY-MM-DD") +
        " " +
        moment(time).format("HH:mm:ss");
      return this.horariosIndisponiveis.find(item => {
        return (
          item.horario == horario && item.cod_escritorio == this.escritorio
        );
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .mx-datepicker {
  margin-top: 5px;
  width: 100%;
}
</style>
